// extracted by mini-css-extract-plugin
module.exports = {"svg":"styles_svg_sBalMRWbW3QQTwJWC5DZL","image":"styles_image_lfrU_SyhjjnvSGroZQwUb"};